import React from 'react';
import { cloneDeep } from 'lodash';
import addDomainToPath from 'commons/addDomainToPath';
import browserStorage from 'components/consumer/browser-storage';

export const addMainImages = collections => {
  const imageDir = 'https://joybird2.imgix.net/static-v1/collections-page';
  const imageDir1 = addDomainToPath('/user-uploads-staging/');
  const imageDir2 = addDomainToPath('/public_img/');
  // First matched image is used for the collection thumnail, the rest are in sidebar
  const images = [
    `${imageDir}/Anton-Daybed-Royal-Peacock-T3-378.jpg`,
    `${imageDir}/Anton-Daybed-Royale-Peacock-T2-079.jpg`,
    `${imageDir}/Aubrey-Chair-Vibe-Aquatic-T2-008.jpg`,
    `${imageDir}/Aubrey-Sofa-Vibe-Aquatic-T3-300.jpg`,
    `${imageDir}/Braxton-Sleeper-Sofa-Royale-Evergreen-T2-063.jpg`,
    `${imageDir}/Braxton-Sofa-Bentley-Indigo-T3-054-x.jpg`,
    `${imageDir}/Braxton-Sofa-Taylor-Felt-Grey-T2-147.jpg`,
    `${imageDir}/Briar-Leather-Sofa-Santiago-Ale-T2-084.jpg`,
    `${imageDir}/Briar-Sofa-Sunbrella-Premier-Fog-T2-221.jpg`,
    `${imageDir}/Briar-Storage-Sectional-Royale-Cobalt-T2-201.jpg`,
    `${imageDir}/Bryant-U-Sofa-Bumper-Sectional-T2-126-x.jpg`,
    `${imageDir}/Collection-Bryant-Petite.jpg`,
    `${imageDir}/Collection-Chelsea.jpg`,
    `${imageDir}/Chelsea-Daybed-Royale-Blush-T2-063.jpg`,
    `${imageDir}/Chelsea-Daybed-Royale-Blush-T2-079.jpg`,
    `${imageDir}/Eastwood-Chair-Key-Largo-Grass-SM-041.jpg`,
    `${imageDir}/Eliot-Grand-Sofa-Lucky-Turquoise-T2-126.jpg`,
    `${imageDir}/Eliot-Leather-Chair-Santiago-Camel-T2-049.jpg`,
    `${imageDir}/Eliot-Sofa-Royale-Ash-T2-063.jpg`,
    `${imageDir}/Smart-Downsizing-Tips-Eliot-Sleeper-Sofa-Bennet-Charcoal-T3-117.jpg`,
    `${imageDir}/Holt-Sectional-Nova-Olive-T2-071-x.jpg`,
    `${imageDir}/Holt-Sofa-Mixology-Moonstone-T2-031.jpg`,
    `${imageDir}/Holt-Sofa-Synergy-Pewter-T2-052-x.jpg`,
    `${imageDir}/Holt-Sofa-Synergy-Pewter-T2-090.jpg`,
    `${imageDir}/Collection-Holt-Petite.jpg`,
    `${imageDir}/Hughes-Chair-Notion-Appletini-T3-432.jpg`,
    `${imageDir}/Hughes-Sofa-Santigo-Ale-T2-013.jpg`,
    `${imageDir}/Hughes-Sofa-Vibe-Aquatic-T3-201.jpg`,
    `${imageDir}/Korver-Loveseat-Cordova-Picante-T2-027-x.jpg`,
    `${imageDir}/Levi-Loveseat-Notion-Thunderbird-T2-024.jpg`,
    `${imageDir}/Levi-Sofa-Notion-Thunderbird-T2-157.jpg`,
    `${imageDir}/Lewis-Corner-Sectional-Synergy-Oatmeal-T2-079.jpg`,
    `${imageDir}/Lewis-Ottoman-Synergy-Oatmeal-T2-038.jpg`,
    `${imageDir}/Collection-Liam.jpg`,
    `${imageDir}/Liam-Leather-Sofa-Toledo-Camel-T2-050.jpg`,
    `${imageDir}/Liam-Sofa-Palermo%20Coffee-T2-038.jpg`,
    `${imageDir}/Liam-Sofa-Vibe-Aquatic-T2-073.jpg`,
    `${imageDir}/Collection-Logan.jpg`,
    `${imageDir}/Logan_Modular_Sectional_1_Final.jpg`,
    `${imageDir}/Logan-Modular-Sofa-Royale-Blush-T2-174.jpg`,
    `${imageDir}/Photography-Test-Soto-Chair-Cushion-Pile-T3-098.jpg`,
    `${imageDir}/Soto-Chair-impact-Flurry-T3-544.jpg`,
    `${imageDir}/Soto-Chair-Taylor-Felt-Grey-T3-411.jpg`,
    `${imageDir}/Preston-Corner-Sectional-Royale-Cobalt-T2-493.jpg`,
    `${imageDir}/Preston-Reversible-Sectional-Cordova-Amber-T2-072.jpg`,
    `${imageDir}/Preston-Sofa-Taylor-Felt-Grey-T2-116.jpg`,
    `${imageDir}/Roddy-collection.jpg`,
    `${imageDir1}/collections-haine-1589521784128.jpeg`,
    `${imageDir1}/collections-daya-1589521820249.jpeg`,
    `${imageDir2}/hopson-collections.jpg`,
    `${imageDir}/Collection-Aime.jpg`,
    `${imageDir}/Collection-Antony.jpg`,
    `${imageDir}/Sebastian-Modular-Chaise-Sectional-Royale-Forest-230407-T3-0687.jpg`,
    `${imageDir}/Diane-Modular-Chaise-Sectional-Royale-Berry-221116-T3-0110.jpg`,
    `${imageDir}/20210623-Denna-Grand-Sofa-Tussah-Snow-T3Summer3516.jpg`,
    `${imageDir}/Amelia-Sofa-Crave-Caribbean-Twist-230405-T3-0199.jpg`,
    `${imageDir}/20210623-Wilder-Corner-Sectional-square.jpg`,
    `${imageDir}/Miller-Sofa-Harper-Cinnamon-230821-T3-0208.jpg`,
    `${imageDir}/Arwen_Corner_Sectional_0068.jpg`,
  ];
  const formattedCollections = collections?.map(collection => {
    if (!collection || typeof collection?.name !== 'string') {
      return collection;
    }
    const collectionName = collection?.name
      .toLowerCase()
      .replace(/collection|\s+/g, '');

    if (!images || !Array.isArray(images)) {
      return {
        ...collection,
        images: [],
      };
    }
    const filteredImages = images
      .filter(url =>
        url.toLowerCase().replace(/-/g, '').includes(collectionName)
      )
      .map(url => ({ url }));

    return {
      ...collection,
      images: filteredImages,
    };
  });
  return formattedCollections.filter(col => col.images.length > 0);
};

export const withState = Component =>
  class extends React.Component {
    state = {
      filters: {},
      isFiltered: false,
      selectedCollection: null,
      isMobileFiltersOpen: false,
    };

    componentDidMount() {
      let prevFilters = browserStorage().getItem('collections.filters');
      if (prevFilters) {
        prevFilters = JSON.parse(prevFilters);
        const filterTypes = prevFilters ? Object.keys(prevFilters) : null;
        if (filterTypes) {
          this.setState({ filters: { ...prevFilters } });
        }
        browserStorage().removeItem('collections.filters');
      }
    }

    getIsFiltered = (filters = this.state.filters) => {
      let isFiltered = false;

      for (const values of Object.values(filters)) {
        if (values && Object.keys(values).length) {
          isFiltered = true;
          break;
        }
      }

      return isFiltered;
    };

    onFilterChange = (filterField, filterOption) => {
      this.setState(prevState => {
        const filters = cloneDeep(prevState.filters);

        if (filters[filterField] && filters[filterField][filterOption]) {
          delete filters[filterField];
        } else {
          filters[filterField] = { [filterOption]: true };
        }

        return {
          filters,
          isFiltered: this.getIsFiltered(filters),
        };
      });
    };

    clearFilterField = filterField => {
      this.setState(prevState => {
        const filters = cloneDeep(prevState.filters);
        delete filters[filterField];

        return { filters, isFiltered: this.getIsFiltered(filters) };
      });
    };

    onSelectCollection = selectedCollection => {
      this.setState({ selectedCollection });
    };

    clearAllFilters = () => {
      this.setState({ filters: {}, isFiltered: false });
    };

    openMobileFilters = () => {
      this.setState({ isMobileFiltersOpen: true });
    };

    closeMobileFilters = () => {
      this.setState({ isMobileFiltersOpen: false });
    };

    render() {
      const state = {
        filters: this.state.filters,
        isFiltered: this.state.isFiltered,
        selectedCollection: this.state.selectedCollection,
        isMobileFiltersOpen: this.state.isMobileFiltersOpen,
      };
      const actions = {
        addMainImages,
        onFilterChange: this.onFilterChange,
        clearFilterField: this.clearFilterField,
        onSelectCollection: this.onSelectCollection,
        clearAllFilters: this.clearAllFilters,
        openMobileFilters: this.openMobileFilters,
        closeMobileFilters: this.closeMobileFilters,
      };

      return <Component state={state} actions={actions} {...this.props} />;
    }
  };
